// gtm.js
import TagManager from "react-gtm-module";
const gtmId = "G-7N3WN5PM86"; // Replace with your GTM ID

export const initializeTagManager = () => {
  TagManager.initialize({ gtmId });
};
